// @flow
import smartNav from '../smartNav/smartNav';

const smartSearch = smartNav({ path: '/search' });
export default smartSearch;
